<template>
  <v-layout
    class="app-bar"
    align-center
  >
    <div class="d-flex align-center" @click="$router.push('/')">
      <div class="size-24 white--text pointer">
        Volt.Land
      </div>
    </div>

    <v-spacer></v-spacer>

    <NavActions />
  </v-layout>
</template>

<script>
import NavActions from  './NavActions'

export default {
  name: 'app-bar',
  components: {
    NavActions
  }
}
</script>

<style lang="scss" scoped>
.app-bar {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #020B2D !important;
  box-shadow: none;
  padding: 10px 20px;
  margin-bottom: -69.5px;
  z-index: 9999999
}
</style>